import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-models-landing-page',
  templateUrl: './vehicle-models-landing-page.component.html',
  styleUrls: ['./vehicle-models-landing-page.component.scss']
})
export class VehicleModelsLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
